<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>
            </div>
        </div>

        

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_cont">
                <div class="main_col">
                    <div class="innerform" v-show="innerformid==1">
                        <GrcCombo ref="BEFIZTIPUS" v-model="BefizTipusID" grc_labeltext="Befizetés típusa:"
                        grc_labelmode="above" grc_labelwidth="200px" grc_dropdownminwidth="300"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('BEFIZTIPUS')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:innerindexbroadcast="BEFIZTIPUS_InnerIndexBroadcasted"
                        v-on:grc-keydown-enter="SetControlToFocus('txtNev');"
                        style="margin-bottom:20px;"
                        />

                        <GrcText ref="txtNev" grc_labeltext="Családi és utóneve:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                        style="margin-bottom:20px;"
                        />

                        <GrcDate ref="txtSzuletesiIdo" v-model="SzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('txtEmailIf');"
                        v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        style="margin-bottom:20px;"
                        />

                        <GrcNum ref="txtTagkod" v-model="tagkod" v-show="ShowTagkodAdoazon"
                        grc_labeltext="<span style='color:red;'>Tagkód:</span>" grc_labelmode="above" grc_labelwidth="200px"
                        grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('txtAdoazon');"
                        style="margin-bottom:20px;"
                        />

                        <GrcAdoazon ref="txtAdoazon" v-model="adoazon" v-show="ShowTagkodAdoazon"
                        grc_labeltext="<span style='color:red;'>Adóazonosító jel:</span>" grc_labelmode="" grc_labelwidth="200px"
                        v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
                        style="margin-bottom:20px;"
                        />


                        <GrcText ref="txtEmailCim" grc_labeltext="Értesítési e-mail cím:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('txtOsszeg');"
                        style="margin-bottom:20px;"
                        />

                        <GrcNum ref="txtOsszeg" v-model="osszeg" 
                        grc_labeltext="Összeg:" grc_labelmode="above" grc_labelwidth="200px"
                        grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('RENDSZERESNAP');"
                        />

                        <GrcCombo ref="RENDSZERESNAP" v-model="RENDSZERESNAPID" grc_labeltext="Esedékesség:" v-show="IsRendszeres"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('RENDSZERESNAP')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        style="margin-bottom:20px; margin-top: 17px;"
                        />


                        <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                        <tr>
                            <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkFelhFelt" /></td>
                            <td valign="top" style="text-align:justify; font-family:'PremiumDefault'; font-size:14px; line-height:18px; color:#222;" v-html="feltetel">
                            </td>
                        </tr>
                        </table>            


                        <div class="btn_cont">

                            <GrcButton grc_text="TOVÁBB A BANKKÁRTYÁS FIZETÉSI OLDALRA" @grc-click="btnStartPreparePayment_click" grc_readonly="false" 
                            grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="338px"
                            grc_buttonpos="right"
                            grc_textalign="center"
                            grc_righticon="<i class='fas fa-chevron-right'></i>"
                            style="display:inline-block;" />                    

                        </div>

                    </div>
                    <div class="innerform" v-show="innerformid==2">
                        <div class="infotext" v-html="BefizResultInfoText" />
                        <div class="infotext" style="margin-top:20px;" v-html="TokenRegResult_text" v-show="IsTokenReg" />

                        <GrcButton grc_text="Újra próbálom" @grc-click="btnUjraProbal_click" grc_readonly="false" 
                        grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="220px"
                        grc_buttonpos="right"
                        grc_textalign="center"
                        grc_righticon="<i class='fas fa-chevron-right'></i>"
                        style="display:inline-block; margin-top:30px;" 
                        v-show="(Sikeres!=1)&&(IsTokenReg==false)"
                        />                    

                    </div>



                </div>
                <div class="main_col">
                    <div class="infotext" v-html="infotext" />
                </div>
            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcAdoazon from '../GrcComponents/GrcAdoazon.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'frmBefizetes',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcDate,
      GrcNum,
      GrcAdoazon,
      GrcCheckboxMobile
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmBefizetes",
            gPopupControlName:"",

            innerformid:0,
            title:"",
            infotext:"",
            BefizTipusID:0,
            BEFIZTIPUSLIST:[],
            SzuletesiIdo:"",
            osszeg:0,
            tagkod:0,
            adoazon:"",
            feltetel:"",
            ShowTagkodAdoazon:false,
            btnPreparePayment_text:"TOVÁBB A BANKKÁRTYÁS FIZETÉSI OLDALRA",
            BefizResultInfoText:"",
            IsTokenReg:"",
            TokenRegResult_text:"",
            RENDSZERESNAPID:0,
            IsRendszeres:false,
            KampanyNev:"",
            Sikeres:0,
            
      }
  },
  model: {
  },  
  methods:{

    btnUjraProbal_click()
    {
        this.innerformid = 1;
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmBefizetes", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        if (pNextComp == "txtEmailIf")
        {
            if (this.ShowTagkodAdoazon) { pNextComp = "txtTagkod"; }
            else { pNextComp = "txtEmailCim"; }
        }

        if (pNextComp == "RENDSZERESNAP")
        {
            if (this.IsRendszeres == false) { return; }
        }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");
        this.infotext = this.GetTextBookItem("info_text");
        this.feltetel = this.GetTextBookItem("feltetel");
        this.TokenRegResult_text = this.GetTextBookItem("TokenRegResult_text");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
        this.$refs.BEFIZTIPUS.HideError();
        this.$refs.txtNev.HideError();
        this.$refs.txtSzuletesiIdo.HideError();
        this.$refs.txtTagkod.HideError();
        this.$refs.txtAdoazon.HideError();
        this.$refs.txtEmailCim.HideError();
        this.$refs.txtOsszeg.HideError();
      },

    async btnStartPreparePayment_click()
    {
        this.HideErrors();

        if (this.$refs.chkFelhFelt.GetValue() == 0)
        {
            await this.ShowInfoDialog("A felhasználási feltételek elfogadása kötelező!", 200);
            return;
        }

        var ErrorCompName = "";

        if (this.$refs.BEFIZTIPUS.GetValue() == 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "BEFIZTIPUS"; }
            this.$refs.BEFIZTIPUS.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtNev.GetText() == "")
        {
            if (ErrorCompName == "") { ErrorCompName = "txtNev"; }
            this.$refs.txtNev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiIdo.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo"; }
          this.$refs.txtSzuletesiIdo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.ShowTagkodAdoazon)
        {
            if ((this.$refs.txtTagkod.GetValue() == 0) && (this.$refs.txtAdoazon.GetText() == ""))
            {
                if (ErrorCompName == "") { ErrorCompName = "txtTagkod"; }
                this.$refs.txtTagkod.ShowError("A tagkód és/vagy adóazonosító jel megadása kötelező!");
                this.$refs.txtAdoazon.ShowError("A tagkód és/vagy adóazonosító jel megadása kötelező!");
            }
        }


        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          if (this.$refs.txtEmailCim.GetText() == "")
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
          }
          else
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "email_format_error"));
          }
        }

        if (this.$refs.txtOsszeg.GetValue() == 0)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtOsszeg"; }
          this.$refs.txtOsszeg.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.BEFIZTIPUS.GetValue() == 2)
        {
            if (this.$refs.RENDSZERESNAP.GetValue() == 0)
            {
            if (ErrorCompName == "") { ErrorCompName = "RENDSZERESNAP"; }
            this.$refs.RENDSZERESNAP.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
            }
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        this.PreparePayment();

    },

    async PreparePayment()
    {
        this.scrollToTop();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            iBefizTipusID: this.$refs.BEFIZTIPUS.GetValue(),
            sNev: this.$refs.txtNev.GetText(),
            sSzuletesiIdo: this.$refs.txtSzuletesiIdo.GetText(),
            iTagkod: this.$refs.txtTagkod.GetValue(),
            sAdoazon: this.$refs.txtAdoazon.GetText(),
            sEmailCim: this.$refs.txtEmailCim.GetText(),
            sOsszeg: this.$refs.txtOsszeg.GetValue(),
            iRendszeresNapID: this.$refs.RENDSZERESNAP.GetValue(),
            sKampanyNev: this.KampanyNev,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmBefizetes_PreparePayment", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {

            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }


        //console.log(Q.PAYMENT);

        this.$refs.GRCDB.HideLoading();
        
        if (Q.HIBA[0].intResult != 1)
        {
            this.ShowInfoDialog(Q.HIBA[0].strResult, 200);
            this.ShowTagkodAdoazon = true;
            return;
        }

        //console.log(this.SIMPLE_LIVEUPDATE_URL);

        var SIMPLE_LIVEUPDATE_URL = Q.PAYMENT[0].SIMPLE_LIVEUPDATE_URL;
        var TIMEOUT_URL = Q.PAYMENT[0].PAYCENTER_TIMEOUT;
        var BACK_REF = Q.PAYMENT[0].PAYCENTER_BACKREF;

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = SIMPLE_LIVEUPDATE_URL;
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "MERCHANT");
        myInput.setAttribute("id", "MERCHANT");
        myInput.setAttribute("value", Q.PAYMENT[0].MERCHANT);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_REF");
        myInput.setAttribute("id", "ORDER_REF");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_REF);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_DATE");
        myInput.setAttribute("id", "ORDER_DATE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_DATE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PNAME[]");
        myInput.setAttribute("id", "ORDER_PNAME");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PNAME);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PCODE[]");
        myInput.setAttribute("id", "ORDER_PCODE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PCODE);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PRICE[]");
        myInput.setAttribute("id", "ORDER_PRICE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PRICE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_VAT[]");
        myInput.setAttribute("id", "ORDER_VAT");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_VAT);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_QTY[]");
        myInput.setAttribute("id", "ORDER_QTY");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_QTY);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PRICES_CURRENCY");
        myInput.setAttribute("id", "PRICES_CURRENCY");
        myInput.setAttribute("value", "HUF");
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "TIMEOUT_URL");
        myInput.setAttribute("id", "TIMEOUT_URL");
        myInput.setAttribute("value", TIMEOUT_URL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "BACK_REF");
        myInput.setAttribute("id", "BACK_REF");
        myInput.setAttribute("value", BACK_REF);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "BILL_EMAIL");
        myInput.setAttribute("id", "BILL_EMAIL");
        myInput.setAttribute("value", Q.PAYMENT[0].BILL_EMAIL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_HASH");
        myInput.setAttribute("id", "ORDER_HASH");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_HASH);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PAY_METHOD");
        myInput.setAttribute("id", "PAY_METHOD");
        myInput.setAttribute("value", "CCVISAMC");
        myForm.appendChild(myInput);

        if (Q.PAYMENT[0].LU_ENABLE_TOKEN == "1")
        {
            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_ENABLE_TOKEN");
            myInput.setAttribute("id", "LU_ENABLE_TOKEN");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_ENABLE_TOKEN);
            myForm.appendChild(myInput);

            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_TOKEN_TYPE");
            myInput.setAttribute("id", "LU_TOKEN_TYPE");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_TOKEN_TYPE);
            myForm.appendChild(myInput);
        }


        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        


    },


    BEFIZTIPUS_InnerIndexBroadcasted(pIndex)
    {
        if (this.BefizTipusID != this.BEFIZTIPUSLIST[pIndex].id)
        {
            this.$refs.BEFIZTIPUS.HideError();
        }

        this.IsRendszeres = (this.BEFIZTIPUSLIST[pIndex].id == 2);
    },


    async Init()
    {
        //console.log(GRCAPP_GetParameters);

        this.InfoText = "";

        var param_refnum = "";
        if ((GRCAPP_GetParameters.ALIAS == "befizetes") && (GRCAPP_GetParameters.PC_REFNUM != "") && (GRCAPP_GetParameters.PC_REFNUM != undefined))
        {
            param_refnum = GRCAPP_GetParameters.PC_REFNUM;
            GRCAPP_GetParameters.PC_REFNUM = "";
        }

        var lnkazon = "";
        if ((GRCAPP_GetParameters.ALIAS == "befizetes") && (GRCAPP_GetParameters.LNKAZON != "") && (GRCAPP_GetParameters.LNKAZON != undefined))
        {
            lnkazon = GRCAPP_GetParameters.LNKAZON;
            GRCAPP_GetParameters.LNKAZON = "";
        }

        if (GRCAPP_GetParameters.KMP != undefined)
        {
            this.KampanyNev = GRCAPP_GetParameters.KMP;
        }


        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sKampanyNev: this.KampanyNev,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.BEFIZTIPUSLIST = Q.BEFIZTIPUS;

        this.$refs.BEFIZTIPUS.SetDataSource(this.BEFIZTIPUSLIST);
        this.$refs.BEFIZTIPUS.SetValue(0);

        this.$refs.RENDSZERESNAP.SetDataSource(Q.RENDSZERES_NAP);
        this.$refs.RENDSZERESNAP.SetValue(0);

        if (lnkazon != "")
        {
            QP = {
                sAzonosito: lnkazon
            };
            var Q;
            await this.$refs.GRCDB.GetData("frmBefizetes_GetLinkData", QP).then(res => { Q = res; });

            if (Q.APPERR[0].ERR != "")
            {
                if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
                {
                    this.$emit("handlecommerror", Q.APPERR[0].ERR);
                }
                return;
            }


            if (Q.APPERR[0].ERR == "")
            {
                if (Q.RESULT.length > 0)
                {
                    this.$refs.BEFIZTIPUS.SetValue(Q.RESULT[0].BefizetesTipusID);
                    this.$refs.txtNev.SetText(Q.RESULT[0].Nev);
                    this.$refs.txtSzuletesiIdo.SetText(Q.RESULT[0].SzuletesiIdo);
                    this.$refs.txtTagkod.SetValue(Q.RESULT[0].Tagkod);
                    this.$refs.txtEmailCim.SetText(Q.RESULT[0].EmailCim);
                    this.$refs.txtOsszeg.SetValue(Q.RESULT[0].Osszeg);
                }
            }
        }



        if (param_refnum != "")
        {
            QP = {
                sRefnum: param_refnum
            };
            var Q;
            await this.$refs.GRCDB.GetData("frmBefizetes_GetTXDATA", QP).then(res => { Q = res; });

            if (Q.APPERR[0].ERR != "")
            {

                this.$refs.GRCDB.HideLoading();
                if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
                {
                    this.$emit("handlecommerror", Q.APPERR[0].ERR);
                }
                else
                {            
                    this.ShowInfoDialog(Q.APPERR[0].ERR, "250");
                }
                return;
            }

            this.KampanyNev = Q.TXDATA[0].KampanyNev;
            this.Sikeres = Q.TXDATA[0].intResult;

            if ((Q.TXDATA[0].intResult == 1) && (Q.TXDATA[0].SikeresLandingUrl != ""))
            {
                document.location = Q.TXDATA[0].SikeresLandingUrl;
                return;
            }

            this.BefizResultInfoText = Q.TXDATA[0].strResult;
            this.IsTokenReg = Q.TXDATA[0].IsTokenReg;

            this.innerformid = 2;

            if (this.Sikeres == 1)
            {
                this.ShowCustomPopup(param_refnum);
            }
        }
        else
        {
            this.innerformid = 1;
        }

        
        this.$refs.GRCDB.HideLoading();


        
    },

    async ShowCustomPopup(pRefNum)
    {
        this.$refs.GRCDB.ShowLoading(false);



        var QP = {
            sRefnum: pRefNum,
            iScreenWidth: grccomp_getScreenSize().width,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmCustomPopups_GetData", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT[0].PopupTextbookComp != "")
        {
            let PopupUrl = Q.RESULT[0].PopupUrl + "?PC_REFNUM="+pRefNum;

            this.DisplayCustomPopup(Q.RESULT[0].PopupTextbookComp, Q.RESULT[0].PopupWidth, Q.RESULT[0].PopupHeight, Q.RESULT[0].PopupMobilWidth, Q.RESULT[0].PopupMobilHeight, PopupUrl);
        }
    },

    async DisplayCustomPopup(PopupTextbookComp, PopupWidth, PopupHeight, PopupMobilWidth, PopupMobilHeight, PopupUrl)
    {
        let PopupText = grcmain_GetTextBookItem("tech", PopupTextbookComp);

        var DialogResult = "";
        var p = grccomp_dialog_yesno_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), PopupText);             
        p.height = PopupHeight;
        p.width = PopupWidth;
        p.padding_top = -1; //20;

        
        //p.buttons[0].text = "Támogatom";
        p.buttons[0].text = "Tovább";
        p.buttons[0].width = "150px"
        p.buttons[0].default = true;
        p.buttons[1].default = false;
        

        if (grccomp_getScreenSize().width < 400)
        { 
            p.width = PopupMobilWidth; 
            p.height = PopupMobilHeight;
        }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               

        if (DialogResult != "YES") { return; }

        if (PopupUrl.toLowerCase().startsWith("http"))
        {
            window.open(PopupUrl);
        }
        else
        {
            this.$emit("navigate", PopupUrl);
        }

    },





    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: #323232;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px 10px 0px 20px;
}

div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}


@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 30px 0px 20px 0px;
    }
}


</style>